module.exports = __webpack_public_path__ + "static/img/130004.3056e72a.png";